const thousandSeparator = (value: string) => {
    return Number(value).toLocaleString('en-US').replace(/,/g, ' ');
};

export default thousandSeparator;